import React, { useMemo } from 'react';
import { useRoleplayStore } from 'features/roleplay/Roleplay.store';
import { InputSelect } from 'shared_ui_components';
import { useGetListUsersQuery } from 'features/roleplay/Roleplay.queries';
import User from 'infrastructure/User';
import styles from './AssignRoleplay.module.scss';
import RoleplayUserOption from './RoleplayUserOption';

const RoleplaySelectAssignRep = ({ managerOption = false }) => {
  // Get users information
  const { data: usersList = [], isLoading } = useGetListUsersQuery();

  const formDataAssignRoleplay = useRoleplayStore((state) => state?.formDataAssignRoleplay);
  const setFormDataAssignRoleplay = useRoleplayStore((state) => state?.setFormDataAssignRoleplay);

  const options = useMemo(() => {
    if (!usersList?.length > 0) return [];
    return usersList.map((user) => {
      return {
        label: User.getUserName(user?.user),
        value: user.user.uuid,
        user: user?.user,
      };
    });
  }, [usersList]);

  const handleChange = (newUsers) =>
    setFormDataAssignRoleplay({ ...formDataAssignRoleplay, users: newUsers });

  return managerOption ? null : (
    <div className={styles.selectAssignWrapper}>
      <InputSelect
        label={'Manager'}
        placeholder={isLoading ? 'Loading...' : 'Select Manager'}
        onChange={(values) => handleChange(values)}
        options={options}
        closeMenuOnSelect={true}
        noOptionsMessage={() => 'No managers found'}
        components={{ Option: RoleplayUserOption }}
        disabled={isLoading}
      />
    </div>
  );
};

export default RoleplaySelectAssignRep;
